export default "__VITE_ASSET__29b75fa2__"